import { LoadingCircle } from '@/components'
import { useGetReportsData } from '@/hooks/demands/queries/useGetReportsData'
import {
  reportIssuesFileIssues,
  reportIssuesImageQuality
} from '@/pages/DemandReports/TabsLeft'
import { parseBrazilianDate } from '@/utils/formatDate'
import { formatDuration } from '@/utils/formatDuration'
import { twMerge } from 'tailwind-merge'

export function ReportsDataTable() {
  const { data: reports, isLoading } = useGetReportsData()

  if (isLoading) {
    return (
      <div className="flex size-full items-center justify-center">
        <LoadingCircle size={30} />
      </div>
    )
  }

  if (reports?.length == 0) {
    return (
      <span className="flex size-full ">Não há reportes para a demanda...</span>
    )
  }

  const combinedReasons = {
    ...reportIssuesFileIssues,
    ...reportIssuesImageQuality
  }

  return (
    <section className="size-full overflow-auto pr-4">
      {reports?.map((report, index) => {
        return (
          <div key={`report-${reports.length - index}`}>
            <h2 className="text-lg">Reporte {reports.length - index}</h2>
            <table className="mb-2 mt-2 w-full pr-4">
              <tbody>
                <tr
                  key={`reasons-${index}`}
                  className="h-6 bg-[#CBD1C7] text-labelMedium dark:bg-[#505A50]"
                >
                  <td className="w-[200px] shrink-0 truncate pl-1 text-start">
                    Motivo(s)
                  </td>
                  <td className="w-full text-center">
                    <div className="flex w-full flex-col items-center">
                      {report.reasons?.map((reason, i) => (
                        <div key={`reason-${i}`} className="pb-1 capitalize">
                          {combinedReasons[reason]?.title ?? reason}
                        </div>
                      ))}
                    </div>
                  </td>
                </tr>
                <tr
                  key={`comment-${index}`}
                  className={twMerge('text-labelMedium', 'h-6 items-center')}
                >
                  <td className="w-[200px] shrink-0 truncate pl-1 text-start">
                    Comentários adicionais
                  </td>
                  <td className="w-full text-center">{report.comment}</td>
                </tr>
                <tr
                  key={`notified-${index}`}
                  className={twMerge(
                    'text-labelMedium',
                    'bg-[#CBD1C7] dark:bg-[#505A50]',
                    'h-6 items-center'
                  )}
                >
                  <td className="w-[200px] shrink-0 truncate pl-1 text-start">
                    Notificados
                  </td>
                  <td className="w-full text-center">
                    {report.notifiedPeople}
                  </td>
                </tr>
                <tr
                  key={`reportDate-${index}`}
                  className={twMerge('text-labelMedium', 'h-6 items-center')}
                >
                  <td className="w-[200px] shrink-0 truncate pl-1 text-start">
                    Data de reporte
                  </td>
                  <td className="w-full text-center">{report.reportDate}</td>
                </tr>
                <tr
                  key={`status-${index}`}
                  className={twMerge(
                    'text-labelMedium',
                    'bg-[#CBD1C7] dark:bg-[#505A50]',
                    'h-6 items-center'
                  )}
                >
                  <td className="w-[200px] shrink-0 truncate pl-1 text-start">
                    Status
                  </td>
                  <td className="w-full text-center">{report.status || '-'}</td>
                </tr>
                <tr
                  key={`applicant-${index}`}
                  className={twMerge('text-labelMedium', 'h-6 items-center')}
                >
                  <td className="w-[200px] shrink-0 truncate pl-1 text-start">
                    Solicitante
                  </td>
                  <td className="w-full text-center">{report.applicant}</td>
                </tr>
                {(() => {
                  const reportDate = parseBrazilianDate(report.reportDate)
                  const resolvedDate = report.resolvedDate
                    ? parseBrazilianDate(report.resolvedDate)
                    : null
                  if (!reportDate) return null

                  if (resolvedDate) {
                    const resolutionTime = report.resolutionTime ? report.resolutionTime : 0
                    console.log(resolutionTime)
                    return (
                      <>
                        <tr
                          key={`resolvedDate-${index}`}
                          className={twMerge(
                            'text-labelMedium',
                            'h-6 items-center',
                            'bg-[#CBD1C7]'
                          )}
                        >
                          <td className="w-[200px] shrink-0 truncate pl-1 text-start">
                            Data de resolução
                          </td>
                          <td className="w-full text-center">
                            {report.resolvedDate}
                          </td>
                        </tr>
                        <tr
                          key={`resolutionTime-${index}`}
                          className={twMerge(
                            'text-labelMedium',
                            'h-6 items-center'
                          )}
                        >
                          <td className="w-[200px] shrink-0 truncate pl-1 text-start">
                            Tempo de resolução
                          </td>
                          <td className="w-full text-center">
                            {formatDuration(resolutionTime)}
                          </td>
                        </tr>
                      </>
                    )
                  } else {
                    const waitingTime = report.reportWaitingTime ? report.reportWaitingTime : 0
                    return (
                      <tr
                        key={`waitingTime-${index}`}
                        className={twMerge(
                          'text-labelMedium',
                          'h-6 items-center',
                          'bg-[#CBD1C7]'
                        )}
                      >
                        <td className="w-[200px] shrink-0 truncate pl-1 text-start">
                          Tempo de espera
                        </td>
                        <td className="w-full text-center">
                          {formatDuration(waitingTime)}
                        </td>
                      </tr>
                    )
                  }
                })()}
              </tbody>
            </table>
            {index !== reports.length - 1 && (
              <hr className="mb-2 h-0.5 border-0 bg-[#CBD1C7] dark:bg-[#505A50]" />
            )}
          </div>
        )
      })}
    </section>
  )
}
